import { useEffect } from 'react';
import { useHubspotUserIdentityMutation } from '@/store/apis/userApi';

export function useHubspotIdentify(email?: string) {
  const [hubspotUserIdentity] = useHubspotUserIdentityMutation();

  useEffect(() => {
    if (!email) {
      console.log('##HUBSPOT [SKIP] No user email provided');
      return;
    }

    const identify = async () => {
      try {
        console.log('##HUBSPOT [IDENTIFY] Fetching visitor token for:', email);

        // Fetch token from backend
        const response = await hubspotUserIdentity({ email }).unwrap();
        console.log('##HUBSPOT [RESPONSE] Response:', response);

        const token = response.data?.token;
        if (!token) {
          throw new Error('No HubSpot visitor token found in response');
        }

        // Apply identification settings
        (window as any).hsConversationsSettings = {
          ...(window as any).hsConversationsSettings,
          loadImmediately: false,
          identificationEmail: email,
          identificationToken: token,
        };
        console.log('##HUBSPOT [SETTINGS] hsConversationsSettings applied');

        // Ensure we always try to load the widget once script is ready
        let retries = 0;
        const checkWidget = () => {
          const widget = (window as any).HubSpotConversations?.widget;
          if (widget?.load) {
            console.log('##HUBSPOT [READY] Widget detected, calling load()');
            widget.load();
          } else if (retries < 20) {
            retries++;
            console.log('##HUBSPOT [WAIT] Widget not ready, retrying...');
            setTimeout(checkWidget, 500);
          } else {
            console.warn('##HUBSPOT [TIMEOUT] Widget never initialized');
          }
        };

        // Register onReady hook (for safety)
        (window as any).hsConversationsOnReady =
          (window as any).hsConversationsOnReady || [];
        (window as any).hsConversationsOnReady.push(() => {
          console.log('##HUBSPOT [CONFIRM] Widget is ready, calling load()');
          (window as any).HubSpotConversations.widget.load();
        });

        // Kick off retry loop
        checkWidget();
      } catch (err) {
        console.error('##HUBSPOT [ERROR] Failed to fetch visitor token', err);
      }
    };

    identify();
  }, [email, hubspotUserIdentity]);
}
